import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectShortcutRoute: InvariantJiraRoute = {
	name: 'classic-business-shortcut',
	path: '/jira/core/projects/:projectKey/shortcuts',
	exact: true,
};
